import React, { FunctionComponent } from "react";
import Body from "./Body";

interface Props {}

const LandingPage: FunctionComponent<Props> = () => {

    return (
        <Body />
    )
}

export default LandingPage;